(function($){
     $(document).ready(function () {


        // var selectItem = $('div form .gform-body .gfield.gfield--type-fileupload.FormItem');
        // var selectItemLabel = $('div form .gform-body .gfield.gfield--type-fileupload.FormItem > label');
        // selectItem.on('click', function(e){
        //      e.preventDefault();
        // });
        // selectItemLabel.on('click', function(e){
        //      e.preventDefault();
        // });
        
        // var selectItem = $('.gform_fields select');
        // selectItem.on('click', function(e){
            
        //     var $this = $(this);
        //     $(this).focus();
        //     if (($('.gform_fields select').hasClass('gf-select-dropdown_active'))) {
        //         $('.gform_fields select').removeClass('gf-select-dropdown_active');
                
        //         $(this).blur();
        //     } else {
        //         $this.addClass('gf-select-dropdown_active');
        //         $(this).focus();
        //     }
        //      e.stopPropagation();
        // });

//         $(document).on('click', function(e) {
//             $('.gform_fields select').removeClass('gf-select-dropdown_active');
// //             $(this).blur();
//         });

//     });
// //     gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
// // 
// //     }, 10, 3 );
// //     $(document).ready(function () {
// //         
// //         var selectItem = $('.gform_fields select');
// //         selectItem.on('click', function(e){
// //             var $this = $(this);
// // 
// //             if (($('.gform_fields select').hasClass('gf-select-dropdown_active'))) {
// //                 $('.gform_fields select').removeClass('gf-select-dropdown_active');
// //             } else {
// //                 $this.addClass('gf-select-dropdown_active');
// //             }
// // 
// //             e.stopPropagation();
// //             
// //         });
// // 
// //         $(document).on('click', function() {
// //             $('.gform_fields select').removeClass('gf-select-dropdown_active');
// //         });
// // 
// //         // $(".gform_fields select").click(function (e) {
// //         //     e.stopPropagation();
// //         // });
// // 
// // 
    });
})(jQuery);
